import { render, staticRenderFns } from "./kop.vue?vue&type=template&id=44a74ad4&"
import script from "./kop.vue?vue&type=script&lang=js&"
export * from "./kop.vue?vue&type=script&lang=js&"
import style0 from "./kop.vue?vue&type=style&index=0&id=44a74ad4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports